var taricLinksSearch = angular.module('taric.moreinfo.links.search', ['taric.model.links'])
    .controller('SearchTaricLinksController', function (CONSTANTS, TaricLinksSearchModel, $state, $translatePartialLoader, CommonHelper, $filter, $uibModal, $rootScope, $scope, $timeout) {
        var searchTaricLinksCtrl = this;

        //Load data for a given page
        searchTaricLinksCtrl.loadDataFromServer = function(count){
            TaricLinksSearchModel.searchTariffLinks(count).then(function(searchLinksResult) {
                searchTaricLinksCtrl.searchLinksResult =  searchLinksResult;
                searchTaricLinksCtrl.searchClicked = false;
                searchTaricLinksCtrl.searching = false;
            }, function(error){
                searchTaricLinksCtrl.hasError = true;
                searchTaricLinksCtrl.errorCode = error.code;
                searchTaricLinksCtrl.searchClicked = false;
                searchTaricLinksCtrl.searching = false;

            });
        };

        //Handle page change for the quota search result table
        searchTaricLinksCtrl.searchLinksResultPageChanged = function (count) {
            searchTaricLinksCtrl.loadDataFromServer(count);
        };

        searchTaricLinksCtrl.init = function (){
            searchTaricLinksCtrl.loadDataFromServer(1);
            searchTaricLinksCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
        };
        
        searchTaricLinksCtrl.print = function(options){

          	$rootScope.$broadcast('startSpinningPrint');
          	TaricLinksSearchModel.searchTariffLinks().then(function(searchLinksResult) {
            	
          		searchTaricLinksCtrl.searchLinksAllResult = searchLinksResult;
            	setTimeout(function(){

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        validDate: $filter('date')(new Date(), CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qry.link.report.report.title')
                    }, 'p').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });

                }, 1000);
            }, function(error){
                
            	// show errors here
              	$rootScope.$broadcast('stopSpinningPrint');
            });
        };
        
    	$scope.$on('printDocument', function(event, data) {
    		
    		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchTaricLinksCtrl.print, true);
        });

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            searchTaricLinksCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                searchTaricLinksCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });
    });



// WEBPACK FOOTER //
// ./app/taric/moreinfo/links/search/links-search.js